// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__x7u9l","file":"styles_file__3DogU"};